/**
 * 角色管理相关 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';

// API Endpoints
const Api = {
    List: '/ListRoles',
    Create: '/CreateRole',
    Update: '/UpdateRole',
    Delete: '/DeleteRole',
    SavePermissions: '/SaveRolePermissions',
};

/**
 * 分页查询角色
 */
export async function listRoles(params: API.ListRolesReq): Promise<API.ListRolesRsp> {
    const response = await http.post<API.ListRolesRsp>(Api.List, params);
    return response?.Data || { Total: 0, Items: [] };
}

/**
 * 新建角色
 */
export async function createRole(params: API.CreateRoleReq): Promise<API.RoleInfo> {
    const response = await http.post<API.RoleInfo>(Api.Create, params);
    return response?.Data || {};
}

/**
 * 更新角色
 */
export async function updateRole(params: API.UpdateRoleReq): Promise<API.RoleInfo> {
    const response = await http.post<API.RoleInfo>(Api.Update, params);
    return response?.Data || {};
}

/**
 * 删除角色（软删除）
 */
export async function deleteRole(params: API.DeleteRoleReq): Promise<void> {
    await http.post(Api.Delete, params);
}

/**
 * 保存角色的菜单权限
 */
export async function saveRolePermissions(
    params: API.RolePermissionsReq,
): Promise<API.RoleInfo> {
    const response = await http.post<API.RoleInfo>(Api.SavePermissions, params);
    return response?.Data || {};
}
